//TODO: replace this with MUI theme globalDkMUITheme
export default {
  PRIMARY_COLOR_300: "#84F5BA",
  PRIMARY_COLOR_500: "#41E58F",
  PRIMARY_COLOR_700: "#35C379",

  SECONDARY_COLOR_100: "#F1F7FF",
  SECONDARY_COLOR_300: "#B7D4FF",
  SECONDARY_COLOR_700: "#0000F5",

  TERTIARY_COLOR_0: "#FFFFFF",
  TERTIARY_COLOR_200: "#EEEEF2",
  TERTIARY_COLOR_500: "#999999",
  TERTIARY_COLOR_900: "#222222",

  DESTRUCTIVE_COLOR_700: "#FF737E",
};
